import React, { useEffect, useRef, useState } from "react";
import { jsonrepair } from "jsonrepair";
import { Button, message } from "antd";
import moment from "moment";

import SelectPolicyItemModal from "./SelectPolicyItemModal";
import { statusLableColor } from "./statusLableColor";
import PatientDropdown from "./PatientDropDown";
import AddPatientModal from "./AddPatientModal";

import calendarCircle from "../../assets/icons/calendar-circle.svg";
import rightArrow from "../../assets/icons/arrow-right.svg";
import statusImg from "../../assets/icons/status.svg";

import { controller } from "../../controller";

import "./breakdownstyles.css";

export default function InsuranceBreakDownItem({
  breakdown,
  allPatients,
  selectedBreakdown,
  isSettingPatientId,
  getAllOfficePatients,
  setSelectedBreakdown,
  setIsSettingPatientId,
  setSummaryOfSelectedBreakdown,
}) {
  const [showAddPatient, setShowAddPatient] = useState(false);
  const [tempSelectedPatients, setTempSelectedPatients] = useState({ temp_patient: null, selected_patient: null });
  const [selectedPatient, setSelectedPatient] = useState(undefined);
  const [showSelectPolicyItemModal, setShowSelectPolicyItemModal] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [breakdownToSetPolicy, setBreakdownToSetPolicy] = useState(undefined);

  const dropdownRef = useRef(null);

  const { submission_date, status } = breakdown || {};
  const { statusBackgroundColor, statusColor } = statusLableColor(status);

  function handleViewButton(e) {
    // 1. Identify the dropdown element
    const dropdownElement = (dropdownRef.current && dropdownRef.current.nativeElement) || dropdownRef.current;

    // 2. Identify if the click was on an Ant Design overlay (like the Modal or Dropdown)
    const isOverlayClick = e.target.closest(".ant-select-dropdown") || e.target.closest(".ant-modal-wrap") || e.target.closest(".ant-modal-mask");

    // 3. If it's inside the patient dropdown container OR an overlay, STOP.
    if ((dropdownElement && dropdownElement.contains(e.target)) || isOverlayClick) {
      return;
    }

    setSelectedBreakdown(breakdown);
    if (breakdown.text) setSummaryOfSelectedBreakdown(breakdown.text);
  }

  // Sending a PATCH request to set the patient id for the patient
  // useEffect(
  //   function () {
  //     // return in case that temp patient or selected patient (from the from down) was undefined or null
  //     if (!tempSelectedPatients.selected_patient) return;

  //     async function handleEditInsurancePatient() {
  //       setIsSettingPatientId(true);
  //       try {
  //         await controller.setBreakdownSetPatient({
  //           policy_id: breakdown.procedure_coverages[0].insurance_policy,
  //           breakdown_id: breakdown.id,
  //         });

  //         // Explained about this in front of the counter state
  //       } catch (err) {
  //         console.log(err);
  //         message.error("Something went wrong while setting the patient id.");
  //       } finally {
  //         setIsSettingPatientId(false);
  //       }
  //     }
  //     handleEditInsurancePatient();
  //   },
  //   [tempSelectedPatients],
  // );

  useEffect(function () {
    // Find the match patient for drop down
    const patient = allPatients.find((patient) => patient.id === breakdown.patient);
    setSelectedPatient(patient);

    // Setting the patient name that extracted by agent
    setPatientName(breakdown.text ? JSON.parse(jsonrepair(breakdown.text)).patient_name : "-");
  }, []);

  console.log(selectedPatient);

  return (
    <div className="insurance-breakdown-item" onClick={handleViewButton}>
      <div className="insurance-breakdown-name-after-break">
        <span className="treatment-name">{patientName || "-"}</span>

        {/* This button will be shown when the row layout breaks */}
        <ViewButton customClass="view-breakdown-button-after-break" />
      </div>

      <div className="breakdown-files-submission-status-container">
        <div className="insurance-labels-text breakdown-file-label" ref={dropdownRef}>
          <PatientDropdown
            setShowSelectPolicyItemModal={setShowSelectPolicyItemModal}
            setTempSelectedPatients={setTempSelectedPatients}
            setBreakdownToSetPolicy={setBreakdownToSetPolicy}
            isSettingPatientId={isSettingPatientId}
            setSelectedPatient={setSelectedPatient}
            currentPatientName={breakdown.patient}
            setShowAddPatient={setShowAddPatient}
            selectedBreakdown={selectedBreakdown}
            isApproved={status === "approved"}
            selectedPatient={selectedPatient}
            allPatients={allPatients}
            breakdown={breakdown}
          />
        </div>

        <div className="insurance-labels-text breakdown-submission-label">
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <img src={calendarCircle} alt="calendar-circle" />
            <span style={{ color: "#848696", textWrap: "nowrap" }}>Submission Date: </span>
          </div>
          <span style={{ minWidth: 85 }}>{submission_date ? moment(submission_date).format("DD/MM/YYYY") : "-"}</span>
        </div>

        <div className="insurance-labels-text breakdown-status-label">
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <img src={statusImg} alt="insurance-status" />
            <span>Status: </span>
          </div>

          <span
            style={{
              backgroundColor: statusBackgroundColor,
              color: statusColor,
              padding: "1px 24px",
              borderRadius: 100,
              fontSize: 14,
              width: 123,
              textAlignc: "center",
              textTransform: "capitalize",
              textWrap: "nowrap",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {status}
          </span>
        </div>
      </div>

      {/* This button wont be shown after the layout breaks */}
      <ViewButton customClass="view-breakdown-button-before-break" />

      {/* Modal for adding patients */}
      <AddPatientModal showAddPatient={showAddPatient} setShowAddPatient={setShowAddPatient} getAllOfficePatients={getAllOfficePatients} />

      {/* Select policy item modal */}
      <SelectPolicyItemModal
        breakdownToSetPolicy={breakdownToSetPolicy}
        patientID={selectedPatient && selectedPatient.id}
        showSelectPolicyItemModal={showSelectPolicyItemModal}
        setShowSelectPolicyItemModal={setShowSelectPolicyItemModal}
      />
    </div>
  );
}

function ViewButton({ customClass }) {
  return (
    <div className={customClass}>
      <Button
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          fontSize: 16,
          border: "none",
          paddingRight: 0,
          paddingLeft: 0,
          color: "#6b43b5",
          marginLeft: "auto",
        }}
      >
        <span>View </span>
        <img src={rightArrow} alt="view" />
      </Button>
    </div>
  );
}
